import React, { useState } from 'react';
import CustomSwitch from '../../../../../shared/CustomSwitch/CustomSwitch';
import CustomCheckbox from '../../../../../shared/CustomCheckbox/CustomCheckbox';

const transactions = [
  {
    year: 2024,
    entries: [
      {
        date: 'FEB 10',
        amount: '+$63.77',
      },
      {
        date: 'JAN 10',
        amount: '+$224.77',
      },
    ],
  },
  {
    year: 2023,
    entries: [
      {
        date: 'DEC 10',
        amount: '+$185.44',
      },
      {
        date: 'NOV 10',
        amount: '+$268.15',
      },
      {
        date: 'OCT 10',
        amount: '+$154.38',
      },
      {
        date: 'SEP 10',
        amount: '-$63.16',
      },
      {
        date: 'AUG 10',
        amount: '-$63.16',
      },
      {
        date: 'JUL 10',
        amount: '-$63.16',
      },
      {
        date: 'JUN 10',
        amount: '+$152.84',
      },
      {
        date: 'MAY 10',
        amount: '+$230.56',
      },
      {
        date: 'APR 10',
        amount: '-$63.16',
      },
      {
        date: 'MAR 10',
        amount: '-$63.16',
      },
    ],
  },
];

export default function InvoiceHistory({ checked, onChange, hidden }) {
  return (
    <div
      className={`sub-card ${hidden ? 'card-disabled' : ''}`}
      id="invoice-history"
      style={{
        opacity: hidden ? 0.5 : 1, // dim when hidden
        transition: 'opacity 0.3s', // smooth transition
      }}
    >
      <div className="garden-wall-card-header">
        <h4 className="card-title">Invoice history</h4>
        <CustomSwitch
          checked={checked} // from parent
          onChange={onChange} // from parent
          size="small" // small | medium | large
          color="var(--primary-color)"
        />
      </div>
      <div className="sc-table">
        <div className="sc-table-head">
          <div className="sc-table-head-cell" style={{ maxWidth: 40 }}></div>
          <div className="sc-table-head-cell">Date</div>
          <div className="sc-table-head-cell">Amount</div>
        </div>
        <div className="sc-table-body">
          {transactions.map((tr) => (
            <div key={tr.year}>
              <div className="table-sc-year" style={{ margin: '8px 0' }}>
                {tr.year}
              </div>
              {tr.entries.map((item, index) => (
                <div
                  className="sc-table-row"
                  key={`${tr.year}-${item.date}-${index}`}
                >
                  <div className="sc-table-th-cell" style={{ maxWidth: 40 }}>
                    <CustomCheckbox checked={false} onChange={() => {}} />
                  </div>
                  <div className="sc-table-th-cell">{item.date}</div>
                  <div className="sc-table-th-cell">{item.amount}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
